import FormErrors from "@/components/FormErrors/FormErrors";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import uuidv4 from "uuid/v4";
import { format, addMonths } from "date-fns";
import { JSConn } from "@/utilities/js-conn";
import HmAutocompleteObject from "@/components/Autocomplete/AutocompleteObject.vue";

export default {
  name: "buyQuoteEditForm",
  components: {
    FormErrors,
    LoadingAnimation,
    HmAutocompleteObject,
  },
  props: {
    buyQuoteId: String,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Quote...",
      hasFormErrors: false,
      cancelParams: { name: "workOrders" },
      formErrors: [],
      buyQuote: {
        id: null,
        issued_date: null,
        expiration_date: null,
        quantity: 0,
        tons: 0,
        price: 0.0,
        lot_unit: {},
        lot_unit_id: null,
        work_order: {},
        work_order_id: null,
        status: "pending",
      },
    };
  },
  created() {
    const jsConnLotUnits = new JSConn();
    const jsConnWorkOrders = new JSConn();

    const dataPromises = [
      this.$store.dispatch("needLotUnits", jsConnLotUnits),
      this.$store.dispatch("needWorkOrders", jsConnWorkOrders),
    ];

    if (this.buyQuoteId === "new") {
      Promise.all(dataPromises).then(() => {
        const today = new Date();

        const issuedDate = format(today, "yyyy-MM-dd");
        const expirationDate = format(addMonths(today, 1), "yyyy-MM-dd");

        this.buyQuote = {
          id: uuidv4(),
          issued_date: issuedDate,
          expiration_date: expirationDate,
          quantity: 0,
          tons: 0,
          price: 0.0,
          lot_unit: {},
          lot_unit_id: null,
          work_order: {},
          work_order_id: null,
          status: "pending",
        };
        this.dataLoaded = true;
        this.$nextTick(() => this.$refs.firstInput.select());
      });
    } else {
      // TODO load the data from the api
      this.dataLoaded = true;
    }
  },
  computed: {
    lotUnitsForAutocomplete: function() {
      return this.$store.getters.lotUnitsForAutocomplete;
    },
    workOrdersForAutocomplete: function() {
      return this.$store.getters.workOrdersForAutocomplete;
    },
    totalAmount: function() {
      return this.buyQuote.tons * this.buyQuote.price;
    },
    avgWeight: function() {
      return (this.buyQuote.tons * 2000) / this.buyQuote.quantity;
    },
  },
  methods: {
    updateLotUnit(evt) {
      this.buyQuote.lot_unit = evt;
      this.buyQuote.lot_unit_id = evt.value;
    },
    updateWorkOrder(evt) {
      this.buyQuote.work_order = evt;
      this.buyQuote.work_order_id = evt.value;
    },
    submitForm(evt) {
      evt.preventDefault();
    },
  },
};
